// النظرة العامة (الصفحة الرئيسية للمتجر).
const overviewAr = {
  "ov.greeting_morning": "صباح الخير، {name}",
  "ov.greeting_afternoon": "طاب يومك، {name}",
  "ov.greeting_evening": "مساء الخير، {name}",
  "ov.welcome": "أهلاً بعودتك",
  "ov.live": "متجرك مفتوح للعملاء",
  "ov.locked": "متجرك محمي بكلمة مرور",
  "ov.locked_hint": "لا يراه إلا أنت وفريقك حتى تطلقه.",
  "ov.launch": "أطلق المتجر",
  "ov.trial_left": "{days, plural, zero {انتهت فترتك التجريبية} one {بقي يوم واحد في فترتك التجريبية} two {بقي يومان في فترتك التجريبية} few {بقيت # أيام في فترتك التجريبية} many {بقي # يوماً في فترتك التجريبية} other {بقي # يوم في فترتك التجريبية}}",
  "ov.today": "اليوم",
  "ov.today_sales": "مبيعات اليوم",
  "ov.today_orders": "طلبات اليوم",
  "ov.pulse": "أداء متجرك",
  "ov.period": "الفترة",
  "ov.period.last_7_days": "٧ أيام",
  "ov.period.last_30_days": "٣٠ يوماً",
  "ov.period.last_90_days": "٩٠ يوماً",
  "ov.vs_previous": "مقارنة بالفترة السابقة",
  "ov.no_change": "لا بيانات سابقة",
  "ov.visitors": "الزوار",
  "ov.sales_over_time": "المبيعات عبر الوقت",
  "ov.full_report": "افتح التحليلات",
  "ov.attention": "يحتاج إلى انتباهك",
  "ov.attention.unfulfilled": "طلبات بانتظار التجهيز",
  "ov.attention.unpaid": "طلبات بانتظار الدفع",
  "ov.attention.cod": "طلبات الدفع عند الاستلام",
  "ov.attention.low_stock": "منتجات يقترب نفادها",
  "ov.caught_up": "لا شيء بانتظارك",
  "ov.caught_up_hint": "ستظهر هنا الطلبات الجديدة والمنتجات منخفضة المخزون.",
  "ov.top_products": "الأكثر مبيعاً",
  "ov.top_products_empty": "ستظهر منتجاتك الأكثر مبيعاً هنا بعد أولى مبيعاتك.",
  "ov.units": "{count, plural, zero {لم يُبع شيء} one {قطعة واحدة مباعة} two {قطعتان مباعتان} few {# قطع مباعة} many {# قطعة مباعة} other {# قطعة مباعة}}",
  "ov.storefront": "واجهة متجرك",
  "ov.customize": "تخصيص القالب",
  "ov.domains": "النطاقات",
  "ov.copy_link": "نسخ الرابط",
  "ov.copied": "نُسخ الرابط",
  "ov.quick": "إجراءات سريعة",
  "ov.guide_title": "جهّز متجرك",
  "ov.guide_all": "عرض كل الخطوات ({count})",
  "ov.guide_fewer": "عرض خطوات أقل",
  "ov.guide_left": "{count, plural, zero {لا خطوات متبقية} one {خطوة واحدة متبقية} two {خطوتان متبقيتان} few {# خطوات متبقية} many {# خطوة متبقية} other {# خطوة متبقية}}",
  "ov.no_sales_yet": "لا مبيعات بعد في هذه الفترة. ستظهر هنا مع وصول الطلبات.",
};

export default overviewAr;
